import { GetterTree } from 'vuex';
import { IBMState } from './bm-state.store';
import { IRootState } from '../root-state.store';
import { IPagination } from '../../models/generic';
import { IBMParameter, IBMDetailViewModel } from '../../models/bm/index'
import { ActivityStatus } from '../../common/enums'
import {IApartmentState} from "../apartment/apartment-state.store";

export const getters: GetterTree<IBMState, IRootState> = {
  activityStatus: (state: IBMState): ActivityStatus => state.activityStatus,
  bmsSource: (state: IBMState) => state.bmsSource,
  bmSource: (state: IBMState): {
    activityStatus: ActivityStatus,
    detail: IBMDetailViewModel
  } => state.bmSource,
  bmParameter: (state: IBMState): IBMParameter => state.bmParameter,
  bmMeetingParameter: (state: IBMState): IBMParameter => state.bmMeetingParameter,
  pagination: (state: IBMState): IPagination => state.pagination,
  bmMeetings: (state: IBMState) => state.bmMeetings,
  bmMeeting: (state: IBMState) => state.bmMeeting,
  bmMeetingPlan: (state: IBMState) => state.bmMeetingPlan,
  loaders: (state: IBMState) => state.loaders,
  bmCrudActionStatus: (state: IBMState) => state.crudActionStatus,
  bmEdited: (state: IBMState) => state.bmEdited,
  bmParticipantEdited: (state: IBMState) => state.bmParticipantEdited,
  bmMeetingEdited: (state: IBMState) => state.bmMeetingEdited,
  bmIBEdited: (state: IBMState) => state.bmIBEdited,
  bmPlanEdited: (state: IBMState) => state.bmPlanEdited,
  bmContractorEdited: (state: IBMState) => state.bmContractorEdited,
  bmCommentEdited: (state: IBMState) => state.bmCommentEdited,
  bmMarkerEdited: (state: IBMState) => state.bmMarkerEdited,
  bmCurrent: (state: IBMState) => state.bmCurrent
}



// WEBPACK FOOTER //
// ./src/store/building-monitor/bm-getters.store.ts